const {apiGetMerchantBalance} = require("../../../../../api/merchant/balance");
const {apiAppList} = require("../../../../../api/merchant/app");

module.exports = async ({assetCode, backToDashboard}) => {
  const availableBalance = await apiGetMerchantBalance()
      .then((res) => {
        const balance = (res.balance_merchant.balances || []).find((el) => el.asset_code === assetCode);

        console.log(balance);

        if (!balance) {
          backToDashboard();
          return;
        }

        return balance.available;
      });

  const appsListRaw = await apiAppList();
  const appsListIdsWithBalance = await apiAppList({has_balance: true})
      .then((res) => res.map(({id}) => id));

  const appsList = appsListRaw.map((el) => {
    const hasBalance = appsListIdsWithBalance.includes(el.id);
    return {...el, hasBalance: hasBalance, disabled: !hasBalance};
  }).sort((prev, next) => {
    return next.disabled ? -1 : 1;
  })

  return {availableBalance, appsList};
}
